module.exports = __webpack_public_path__ + "img/taskDodIcon.a95bc9bf.svg";